'use strict';

var React = require("react");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var WeaponCard$PvpcontrollerWeb = require("./WeaponCard.js");

function WeaponCardGrid$Fake(Props) {
  var itemCount = Props.itemCount;
  var items = Belt_Array.make(itemCount, 0);
  return React.createElement("div", {
              style: {
                display: "flex",
                marginTop: "-5px",
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: "center"
              }
            }, Belt_Array.mapWithIndex(items, (function (i, param) {
                    return React.createElement(WeaponCard$PvpcontrollerWeb.Fake.make, WeaponCard$PvpcontrollerWeb.Fake.makeProps(String(i), undefined));
                  })));
}

function WeaponCardGrid(Props) {
  var weapons = Props.weapons;
  return React.createElement("div", {
              style: {
                display: "flex",
                marginTop: "-5px",
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: "center"
              }
            }, Belt_Array.mapWithIndex(weapons, (function (i, weapon) {
                    return React.createElement(WeaponCard$PvpcontrollerWeb.make, WeaponCard$PvpcontrollerWeb.makeProps(weapon, String(i), undefined));
                  })));
}

function Fake_makeProps(prim0, prim1, prim2) {
  var tmp = {
    itemCount: prim0
  };
  if (prim1 !== undefined) {
    tmp.key = prim1;
  }
  return tmp;
}

var Fake = {
  makeProps: Fake_makeProps,
  make: WeaponCardGrid$Fake
};

function makeProps(prim0, prim1, prim2) {
  var tmp = {
    weapons: prim0
  };
  if (prim1 !== undefined) {
    tmp.key = prim1;
  }
  return tmp;
}

var make = WeaponCardGrid;

exports.Fake = Fake;
exports.makeProps = makeProps;
exports.make = make;
/* react Not a pure module */
